import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'admin/voltagem',
		component: Base,
		children: [
			{
				path: '',
				name: 'VoltagemList',
				component: List,
				meta: {
					path: '/admin/voltagem',
					pai: 'Admin',
					title: 'siS - Voltagem',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Voltagem',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'VoltagemNovo',
				component: Form,
				meta: {
					path: '/admin/voltagem',
					pai: 'Admin',
					title: 'siS - Voltagem - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Voltagem',
						class: '',
						active: false,
						url: '/admin/voltagem'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'VoltagemEditar',
				component: Form,
				meta: {
					path: '/admin/voltagem',
					pai: 'Admin',
					title: 'siS - Voltagem - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Voltagem',
						class: '',
						active: false,
						url: '/admin/voltagem'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]